<mat-checkbox *ngIf="!loading" [(ngModel)]="checked" (change)="onChanged($event)" color="{{color}}"></mat-checkbox>
<mat-progress-bar *ngIf="loading" mode="indeterminate" color="{{color}}"></mat-progress-bar>
